import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  &.ant-segmented {\n    padding: 2px;\n    border-radius: 4px;\n    width: 100%;\n    background-color: ",
        ";\n    .ant-segmented-group {\n      .ant-segmented-item {\n        border-radius: 4px;\n        width: 100%;\n        box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n        .ant-segmented-item-label {\n          font-size: 16px;\n          font-weight: 600;\n          color: ",
        ";\n          padding: 10px 12px;\n          line-height: 1.5;\n        }\n      }\n      .ant-segmented-item-selected .ant-segmented-item-label {\n        color: ",
        ";\n      }\n    }\n\n    @media (max-width: 768px) {\n      &.ant-segmented {\n        .ant-segmented-group {\n          .ant-segmented-item-label {\n            font-size: 14px;\n            line-height: 22px;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { Segmented } from "antd";
import styled from "styled-components";
export const Segment = styled(Segmented).withConfig({
    componentId: "sc-13bda633-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_700);
